import { createContext, useState, useContext } from 'react';
import locales from '../data/locales.json';

const LanguageContext = createContext();

// Supported languages in rotation order
const LANGUAGES = ['zh', 'en', 'de'];

// Language display names
const LANGUAGE_NAMES = {
    zh: '中文',
    en: 'EN',
    de: 'DE'
};

// Locale codes for Intl API
const LOCALE_CODES = {
    zh: 'zh-CN',
    en: 'en-US',
    de: 'de-DE'
};

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState('zh'); // Default to Chinese

    const t = (key) => {
        const keys = key.split('.');
        let value = locales[language];
        for (const k of keys) {
            value = value?.[k];
        }
        return value || key;
    };

    // Cycle through languages: zh -> en -> de -> zh
    const toggleLanguage = () => {
        setLanguage(prev => {
            const currentIndex = LANGUAGES.indexOf(prev);
            const nextIndex = (currentIndex + 1) % LANGUAGES.length;
            return LANGUAGES[nextIndex];
        });
    };

    // Get next language name for button display
    const getNextLanguageName = () => {
        const currentIndex = LANGUAGES.indexOf(language);
        const nextIndex = (currentIndex + 1) % LANGUAGES.length;
        return LANGUAGE_NAMES[LANGUAGES[nextIndex]];
    };

    // Get locale code for Intl API (date formatting, etc.)
    const getLocaleCode = () => LOCALE_CODES[language] || 'en-US';

    return (
        <LanguageContext.Provider value={{
            language,
            setLanguage,
            toggleLanguage,
            t,
            languages: LANGUAGES,
            languageNames: LANGUAGE_NAMES,
            getNextLanguageName,
            getLocaleCode
        }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}
